module.exports = __webpack_public_path__ + "static/media/hills.678d2260.svg";